<template>
    <div>
        <LabelList :type="type"></LabelList>
    </div>
</template>

<script>
    import LabelList from './components/labelList';

    export default {
        name: "Custom",
        components: {
            LabelList
        },
        data() {
            return {
                type:"CUSTOM_LABEL"
            };
        }
    }
</script>

<style lang="less" scoped>

</style>